import { useContext, useEffect } from "react";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import AppContext from "./AppContext";

function Admin() {
  const appContext = useContext<any>(AppContext);
  const { surveyResult } = appContext;

  // Ensure navbar is visible on Admin page
  useEffect(() => {
    if (appContext && appContext.isLandingMode) {
      appContext.setIsLandingMode(false);
    }
  }, [appContext]);

  return (
    <Stack direction="column" spacing={2} sx={{ height: "100%" }}>
      <Stack direction="row" spacing={2} justifyContent="space-between">
        <Typography variant="h2">Admin overview</Typography>
        <img src="/image.png" alt="Admin icon" height="74px" width="74px" style={{ zIndex: "-100" }} />
      </Stack>
      {surveyResult.map((item: any, index: number) => (
        <div key={index}>
          <Typography variant="h5">Survey run: {index}</Typography>
          {Object.keys(item).map((key) => (
            <Typography key={key} variant="body2">Key: {key}, Value: {String(item[key])}</Typography>
          ))}
        </div>
      ))}
    </Stack>
  );
}

export default Admin;
